import { render } from "./JitsiPage.vue?vue&type=template&id=d9035df0&ts=true"
import script from "./JitsiPage?vue&type=script&lang=ts&external"
export * from "./JitsiPage?vue&type=script&lang=ts&external"

import "./JitsiPage.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__